import { render, staticRenderFns } from "./r-smart-offer-bundle-treasure-shop.vue?vue&type=template&id=287577c6"
import script from "./r-smart-offer-bundle-treasure-shop.vue?vue&type=script&lang=js"
export * from "./r-smart-offer-bundle-treasure-shop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('287577c6')) {
      api.createRecord('287577c6', component.options)
    } else {
      api.reload('287577c6', component.options)
    }
    module.hot.accept("./r-smart-offer-bundle-treasure-shop.vue?vue&type=template&id=287577c6", function () {
      api.rerender('287577c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/bundle-treasure-shop/r-smart-offer-bundle-treasure-shop.vue"
export default component.exports